import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { CommonService } from '../../services/commonservice';
import { CommonModule } from '@angular/common';
import { IsgGridComponent } from '@mysrc/app/shared/components/isg-grid/isg-grid.component';
import { IsgGridConfig } from '@mysrc/app/shared/models/grid-config.model';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ColDef } from 'ag-grid-community';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'multipleResponse',
  standalone: true,
  imports: [CommonModule, FormsModule, AccordionModule,
    ReactiveFormsModule, IsgGridComponent],
  providers: [CommonService],
  templateUrl: './page-multiple-response.component.html',
  styleUrl: './page-multiple-response.component.scss'
})

export class PageMultipleResponseComponent extends BaseHttpReqRespService {

  @ViewChild('file') myInputVariable: any;
  @ViewChild('deleteOptionConfirmation') deleteModalTemplate!: TemplateRef<any>;
  @ViewChild('CreateCategoryModal') categoryModal!: TemplateRef<any>;


  [x: string]: any;

  public questionOptionId: string = "";
  public questionOptionList: questionOptions[] = [];
  myAppUrl: any;
  public questionId!: number;
  public folderId!: number;
  public folderName!: string;
  public mode!: string;
  public trigger!: string;
 
  responseForm!: FormGroup;
  MULTICHOICE_ENDPOINT= API_ENDPOINTS.MULTICHOICE;
  QUESTION_MATRIX_ENDPOINT = API_ENDPOINTS.QUESTION_MATRIX;
  QUESTION_ENDPOINT = API_ENDPOINTS.QUESTION;
  quesCategoryForm!: FormGroup;  
  public questionCategoryList: questionCategory[] = [];
  public questionCategoryId: number = 0;
  private gridApi: any;
  optionGridConfig: Partial<IsgGridConfig> = {
    height: '250px',
    pagination: false,
    rowDragManaged: true,
  };
  public redirectedSectionId!: number;
  public redirectedSurveyId!: number;
  

  public files: any;
  public imagePath: any;
  public imgURL: any;
  public validImage!: boolean;
  public isHideSidebar: boolean = false;


  constructor(private _router: Router,
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    public http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private EncrDecr: EncrDecrService,
    private modalService: NgbModal,
    @Inject('CONFIG_SETTINGS') configSettings: any
  ) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.myAppUrl = genSettings[<any>'adminApiUrl'];
    this.apiKey = genSettings[<any>'apiKey'];
  }
  backUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      if (this.folderId == -1)
        this._router.navigate(['/question']);
      else
        this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
    }
    else {
      this._router.navigate(['programoverview'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
    }
  }
  saveQuestion() {
    if (this.questionId == undefined) {
      this.questionId = 0;
    }
    let userId = this.EncrDecr.get(localStorage.getItem('userId') ?? "0");
    const data = {
      description: this.responseForm.controls.description.value,
      questionCategoryId: this.responseForm.controls.questionCategoryId.value,
      shortName: this.responseForm.controls.shortName.value,
      questionId: this.questionId?.toString() ?? "0", // ensure string
      type: "MultipleResponse",
      folderId: this.folderId,
      userId: userId
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    this.commonService.httpPostWOHeader(
      this.myAppUrl + '/' + this.MULTICHOICE_ENDPOINT.SAVE_QUESTION,
      data,
      httpOptions
    ).subscribe(result => {
      this.questionId = result;
      this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
      this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];
      var location = window.location.pathname;
      if (location.includes("/client") == false) {
        if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
          this.mapQuestionsToSection(this.questionId, this.redirectedSurveyId, this.redirectedSectionId)
        }
      }
      else {
        if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
          this.mapQuestionsToSection(this.questionId, this.redirectedSurveyId, this.redirectedSectionId)
        }
      }
    });
  }

  ngOnInit() {
    var location = window.location.pathname;
    if (location.includes("/client")) {
      this.isHideSidebar = false;
    }

    this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
    this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];
    this.responseForm = this.formBuilder.group({
      description: new FormControl('', Validators.required),
      questionOption: '',
      isTextboxRequired: false,
      evaluateAndExit: false,
      weightage: new FormControl(''),
      questionCategoryId: new FormControl(''),
      shortName: new FormControl(''),
      optionShortName: new FormControl(''),
      hoverText: new FormControl('')
    });
    this.questionId = +this.route.snapshot.queryParams["questionId"];
    this.folderId = this.route.snapshot.queryParams["folderId"];
    this.folderName = this.route.snapshot.queryParams["folderName"];
    if (this.questionId > 0) {
      this.mode = "Edit";
      this.getQuestion();
    }

    this.quesCategoryForm = this.formBuilder.group({
      'quesCategoryName': new FormControl(null, Validators.required)
    });

    this.getQuestionCategoryList();
  }

  getQuestionCategoryList() {
    this.commonService.httpGet("", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.QUESTION_CATEGORY_LIST).subscribe(result => {
      this.questionCategoryList = result;
    }, error => console.error(error));

  }

  AddQuesCategory() {
    let tmpQuesCategoryName = this.quesCategoryForm.get('quesCategoryName')?.value;
    let resourceIdList = "quesCategoryName=" + tmpQuesCategoryName;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(resourceIdList, this.myAppUrl + '/' +this.QUESTION_ENDPOINT.SAVE_CATEGORY , httpOptions).subscribe(result => {
      this.getQuestionCategoryList();
    }, error => console.error(error));
  }

  ResetQuesCategoryForm() {
    this.quesCategoryForm.reset();
  }

  getQuestion() {
    let parameter = "?questionId=" + this.questionId;
    this.commonService.httpGet("", this.myAppUrl + '/' +this.MULTICHOICE_ENDPOINT.QUESTIONS + parameter).subscribe(response => {
      this.responseForm.patchValue({
        description: response.description,
        weightage: response.weightage,
        questionCategoryId: response.questionCategoryId,
        shortName: response.shortName,

      });
      this.questionOptionList = response.questionOptions;
    }, error => console.error(error));
  }
  addChoice() {
    if (this.questionOptionId == undefined) {
      this.questionOptionId = "0";
    }
    var existOption = this.questionOptionList.find(x => x.description == this.responseForm.controls.questionOption.value && x.questionId == this.questionId);
    if (existOption == undefined) {
      this.addOption();
    }
    else {
      if (this.trigger == "Edit") {
        this.addOption();
        this.showMessage("Option Updated Exists");
      }
      else {
        this.showMessage("Option Already Exists");
      }
      this.messageTimeout();
    }
  }

  addOption() {
    if (this.questionOptionId == undefined) {
      this.questionOptionId = "0";
    }
    if (this.responseForm.controls.description.value != '' && this.responseForm.controls.questionOption.value != '' && this.responseForm.controls.questionOption.value != undefined) {
      let data = {
        option: this.responseForm.controls.questionOption.value,
        questionId: this.questionId?.toString() ?? "0", // ensure string
        questionOptionId: this.questionOptionId?.toString() ?? "0",
        isTextBoxRequired: this.responseForm.controls.isTextboxRequired.value,
        evaluateAndExit: this.responseForm.controls.evaluateAndExit.value,
        imageFile: this.base64textString,
        weightage: this.responseForm.controls.weightage.value,
        hoverText: this.responseForm.controls.hoverText.value,
        optionShortName: this.responseForm.controls.optionShortName.value
      };
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      };
      this.commonService.httpPostWOHeader(
        this.myAppUrl + '/' +this.MULTICHOICE_ENDPOINT.ADD_OPTION,
        data,
        httpOptions
      ).subscribe(result => {
        this.questionOptionList = result;
        this.questionId = this.questionOptionList[0].questionId;
        this.questionOptionId = "0";
        this.responseForm.patchValue({
          questionOption: "",
          isTextboxRequired: false,
          evaluateAndExit: false,
          weightage: "",
          hoverText: "",
          optionShortName: ""
        });
      });

      console.log(this.myInputVariable.nativeElement.files);
      this.myInputVariable.nativeElement.value = "";
      console.log(this.myInputVariable.nativeElement.files);
      this.imgURL = "";
    }
  }

  preview(files: any) {
    this.files = files;
    if (files.length === 0)
      return;

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    var imageUpload = files[0];

    var reader = new FileReader();


    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = () => {
      this.imgURL = reader.result;
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(imageUpload);
    };
    reader.onloadend = () => {

      //reader.onload = this._handleReaderLoaded.bind(this);
      //reader.readAsBinaryString(imageUpload);
    }



  }

  public _handleReaderLoaded(readerEvt: any) {
    this.validImage = false;
    var tempimagevalid = false;
    var binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
    var tempBase64 = "data:image/png;base64," + this.base64textString;
    var img = new Image();
    img.src = tempBase64;
    this.width = img.width;
    this.height = img.height;
    if (img.width != 40) {
      this.validImage = true;
      this.imgURL = "";
      this.base64textString = "";
      return;
    }
    if (img.height != 40) {
      this.validImage = true;
      this.imgURL = "";
      this.base64textString = "";
      return;
    }

    console.log(btoa(binaryString));
  }

  showMessage(params: any) {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) {
      divMessage.style.display = "block";
    }
    var message = document.getElementById('message');

    if (message) {
      message.innerText = params;
    }
  }
  messageTimeout() {
    window.setTimeout(() => {
      this.hideMessage();
    }, 1800);
  }
  hideMessage() {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) {
      divMessage.style.display = "none";
    }
    var message = document.getElementById('message');
    if (message) {
      message.innerText = '';
    }
  }
  public resetQuestion() {
    this.responseForm.controls.description.setValue("");
    this.responseForm.controls.questionCategoryId.setValue("");
  }
  columnDefs: ColDef[] = [
    { headerName: 'QuestionOptionId', field: 'questionOptionId', hide: true },
    { headerName: 'Option', field: 'description', width: 200, filter: true, rowDrag: true, cellRenderer: this.editOptionCellRenderer.bind(this), resizable: true, sortable: true },
    { headerName: 'Weightage', field: 'weightage', width: 100, filter: true, resizable: true },
    { headerName: 'Short Name', field: 'optionShortName', width: 150, filter: true, resizable: true },
    { headerName: 'Hover Text', field: 'hoverText', width: 150, filter: true, autoHeight: true, cellStyle: { 'white-space': 'normal' }, cellRenderer: (params: { value: string }) => '<span class="cell-wrap-text" title="' + params.value + '">' + params.value + '</span>', resizable: true },
    { headerName: 'Is textbox required?', field: 'isTextboxRequired', filter: true, width: 150, cellRenderer: this.CheckboxCellRenderer.bind(this, true), resizable: true },
    { headerName: 'Evaluate and exit', field: 'evaluateAndExit', width: 140, filter: true, cellRenderer: this.CheckboxCellRenderer.bind(this, false), resizable: true },
    { headerName: 'Delete', field: '', width: 90, cellRenderer: this.deleteOptionCellRenderer.bind(this), resizable: true }
  ];

  arrangeOrder() {
    var optionIdList = '';
    this.gridApi.forEachNode(function (rowNode: any) {
      optionIdList = optionIdList + rowNode.data.questionOptionId + ',';
    });
    let data = {
      questionId: this.questionId?.toString() ?? "0", // ensure string
      optionIdList: optionIdList?.toString() ?? "0",     
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    this.commonService.httpPostWOHeader(
      this.myAppUrl + '/' +this.MULTICHOICE_ENDPOINT.ARRANGE_QUESTION_OPTION,
      data,
      httpOptions
    ).subscribe(result => {
      this.questionOptionList = result.questionOptions;
    }, error => console.error(error));
  }

  editOptionCellRenderer(params: any) {
    this.trigger = "Edit";
    const element = this.renderer.createElement('a');
    const attr = this.renderer.createText(params.data.description);
    this.renderer.appendChild(element, attr);
    this.renderer.setAttribute(element, 'href', 'javascript:void(0);');
    this.renderer.listen(element, 'click', () => {
      this.questionOptionId = params.data.questionOptionId;
      this.imgURL = params.data.optionImage;
      this.responseForm.patchValue({
        questionOption: params.data.description,
        isTextboxRequired: params.data.isTextboxRequired,
        evaluateAndExit: params.data.evaluateAndExit,
        weightage: params.data.weightage === null ? '' : params.data.weightage,
        hoverText: params.data.hoverText,
        optionShortName: params.data.optionShortName
      });

    });
    return element;
  }
  CheckboxCellRenderer(isTextBox: any, params: any) {
    const elementI = this.renderer.createElement('i');
    var tmpvalue = false;
    if (isTextBox) {
      tmpvalue = params.data.isTextboxRequired;
    }
    else {
      tmpvalue = params.data.evaluateAndExit;

    }
    if (tmpvalue == true) {
      elementI.setAttribute('class', 'fa fa-check');
    }
    else {
      elementI.setAttribute('class', 'fa fa-close');
    }
    return elementI;
  }
  deleteOptionCellRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    elementI.setAttribute('class', 'fa fa-trash anchor-cursor');
    this.renderer.appendChild(element, elementI);
    this.renderer.listen(element, 'click', () => {

      this.questionOptionId = params.data.questionOptionId;
      this.openDeleteModalForRow();
    });
    return element;
  }
  openDeleteModalForRow() {
    if (this.deleteModalTemplate) {
      this.modalRef = this.modalService.open(this.deleteModalTemplate);
    }
  }
  onQuestionGridReady(params: any) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
  }
  deleteOptions() {

    let data = {
      questionId: this.questionId?.toString() ?? "0", // ensure string
      questionOptionId: this.questionOptionId?.toString() ?? "0"
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    this.commonService.httpPostWOHeader(
      this.myAppUrl + '/' + this.MULTICHOICE_ENDPOINT.REMOVE_OPTION,
      data,
      httpOptions
    ).subscribe
      (data => {
        this.questionOptionList = data;
        this.questionOptionId = "0";
        // Refresh the grid
        if (this.gridApi) {
          this.gridApi.setRowData(this.questionOptionList);
        }
      });
  }

  public resetForm() {
    this.questionOptionId = "0";
    this.responseForm.controls.questionOption.setValue("");
    this.responseForm.controls.isTextboxRequired.setValue(false);
    this.responseForm.controls.evaluateAndExit.setValue(false);
    this.responseForm.controls.weightage.setValue("");
    this.responseForm.controls.hoverText.setValue("");
    this.responseForm.controls.optionShortName.setValue("");
  }
  mapQuestionsToSection(questionid: any, surveyId: any, currentSectionId: any) {
    var concatenated = questionid.toString();

    let questionIdList = "questionIdList=" + concatenated + "&surveyId=" + surveyId + "&sectionId=" + currentSectionId;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(questionIdList, this.myAppUrl + '/' + this.QUESTIONMATRIX_ENDPOINT.MAP_QUESTION_TO_SECTION, httpOptions).subscribe(result => {
      window.setTimeout(() => {
      }, 1200);
    }, error => console.error(error));

  }
  openCategoryModal() {
    if (this.categoryModal) {
      this.modalService.open(this.categoryModal);
    }
  }
  backToSectionUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
        this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
      }
    }
    else {
      this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
    }
  }
}
interface questionOptions {
  questionId: number;
  questionOptionId: number;
  description: string;
  displayOrder: number;
  weightage: string;
  optionShortName: string;
  hoverText: string;
}
interface choices {
  questionOption: string;
  description: string;
  isTextboxRequired: boolean;
  evaluateAndExit: boolean;

}

interface questionCategory {
  questionCategoryId: number;
  questionCategoryName: string;
}

